import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { enumerated } from '~/prix/types/enumerated'
import sql from '~/prix/utils/sql'

export const roadMaintenanceDocumentStatus = enumerated({
  pending: 'Pendente',
  approved: 'Aprovado',
  rejected: 'Rejeitado',
})

export const roadMaintenanceDocumentObject = z.object({
  id: z.string().uuid(),
  maintenanceId: z.string().uuid(),
  privateFileId: z.string().uuid().nullish(),
  gcsIdentifier: z.string().nullish(),
  url: z.string().nullish(),
  fileName: z.string().nullish(),
  mimeType: z.string().nullish(),
  clientId: z.number().int().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
  status: roadMaintenanceDocumentStatus,
})

export type RoadMaintenanceDocumentType = z.infer<typeof roadMaintenanceDocumentObject>

export default roadMaintenanceDocumentObject

export const propertyMap = {
  id: sql`road_maintenance_document.id`,
  maintenanceId: sql`road_maintenance_document.maintenance_id`,
  privateFileId: sql`road_maintenance_document.private_file_id`,
  gcsIdentifier: sql`road_maintenance_document.gcs_identifier`,
  url: sql`road_maintenance_document.url`,
  fileName: sql`road_maintenance_document.file_name`,
  mimeType: sql`road_maintenance_document.mime_type`,
  clientId: sql`road_maintenance_document.client_id`,
  insertUserId: sql`road_maintenance_document.insert_user_id`,
  editUserId: sql`road_maintenance_document.edit_user_id`,
  createdAt: sql`road_maintenance_document.created_at`,
  updatedAt: sql`road_maintenance_document.updated_at`,
  deletedAt: sql`road_maintenance_document.deleted_at`,
  status: sql`road_maintenance_document.status`,
}
